import ResultBadge from "app/components/analytics/shared/ResultBadge";
import MissingEnvVariables, {
  OPTIMAL_ENV_VARIABLES,
} from "app/components/analytics/shared/MissingEnvVariables";
import { _trackTALinkClicked } from "../segmentEvents";
import { EnvironmentVariables, TestPlanProps } from "../type";
import MetadataRow from "./MetadataRow";

export type MetadataType = {
  result?: string;
  created_at: string;
  env: EnvironmentVariables;
  hideMissingEnvNotice?: boolean;
  testPlans?: TestPlanProps[];
  repoUrl?: string | null | undefined;
  linkToBranchTag?: boolean;
  type?: "run";
};

const ResultUI = ({ result, type }) => {
  if (type === "run") {
    return null;
  }

  return <ResultBadge result={result} />;
};

const Metadata = ({
  result,
  created_at,
  env,
  hideMissingEnvNotice,
  testPlans,
  repoUrl,
  linkToBranchTag,
  type,
}: MetadataType) => {
  const missingEnvProps = !OPTIMAL_ENV_VARIABLES.every((envVar) =>
    Object.keys(env).includes(envVar),
  );
  const missingPropValues = Object.values(env).some((envVar) => !envVar);
  const missingEnvVariables = missingEnvProps || missingPropValues;

  return (
    <div className="pt-5 pb-2 max-w-full">
      <div className="flex flex-wrap gap-y-1 gap-x-4 items-center text-xs text-charcoal-500">
        {result && <ResultUI result={result} type={type} />}

        <MetadataRow
          buildNumber={env.number}
          buildUrl={env.url}
          commitSha={env.commit_sha}
          branch={env.branch}
          testPlans={testPlans}
          createdAt={created_at}
          repoUrl={repoUrl}
          linkToBranchTag={linkToBranchTag}
        />

        {!hideMissingEnvNotice && missingEnvVariables && <MissingEnvVariables {...env} />}
      </div>
    </div>
  );
};

export default Metadata;
